"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFutureOfTechHero() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235660" id="eco-friendly-packaging-for-modern-business" className="bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-[60vw] h-[60vw] max-w-[800px] max-h-[800px] bg-chart-2/5 rounded-lg blur-3xl animate-pulse" style={{
        animationDuration: '8s'
      }} />
        <div className="absolute bottom-[-20%] right-[-10%] w-[70vw] h-[70vw] max-w-[1000px] max-h-[1000px] bg-primary/5 rounded-lg blur-3xl animate-pulse" style={{
        animationDuration: '12s',
        animationDelay: '2s'
      }} />
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_10%,transparent_100%)] opacity-20" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        
        {}
        <div ref={headerRef} className={`transition-all duration-1000 ease-out transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md border border-border bg-card/50 backdrop-blur-sm mb-8">
            <Sparkles className="size-4 text-chart-2" />
            <span className="tracking-widest uppercase text-xs md:text-sm text-primary font-mono font-medium">
              Sustainable Solutions
            </span>
          </div>
          
          {}
          <h1 className="text-5xl sm:text-6xl md:text-[80px] font-bold font-serif leading-[1.1] tracking-tighter mb-6 max-w-4xl mx-auto">
            <span className="text-transparent bg-clip-text bg-gradient-to-b from-primary to-primary/80">
              Redefining the
            </span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-chart-2 to-primary">
              Pulp Standard.
            </span>
          </h1>
          
          <p className="text-lg md:text-xl text-foreground/80 max-w-2xl mx-auto mb-12 font-default font-normal tracking-normal">
            Premium kraft paper packaging engineered for the eco-conscious entrepreneur. Strength, safety, and sustainability in every fiber.
          </p>
        </div>

        {}
        <div ref={imageRef} className={`relative w-full max-w-4xl mx-auto mb-16 transition-all duration-1000 delay-300 ease-out transform ${isImageVisible ? "opacity-100 scale-100 translate-y-0" : "opacity-0 scale-95 translate-y-12"}`}>
          {}
          <div className="absolute inset-0 bg-chart-2/10 blur-3xl rounded-lg transform scale-75" />
          
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669361/img/premium_kraft_bag_render.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669361/img/premium_kraft_bag_render.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669361/img/premium_kraft_bag_render.png-wvc-sizes" alt="PackLux Premium Kraft Paper Bag 3D Render" loading="lazy" className="w-full max-w-[400px] h-auto object-contain drop-shadow-xl animate-[pulse_6s_ease-in-out_infinite]" />
          </div>
        </div>

        {}
        <div ref={ctaRef} className={`transition-all duration-1000 delay-500 ease-out transform ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="relative inline-block group">
            {}
            <div className="absolute -inset-1 bg-chart-2 rounded-md blur-md opacity-20 group-hover:opacity-40 transition duration-500 animate-pulse" />
            
            <Link to="/ShopPage" className="relative z-10 block">
              <Button size="lg" className="h-14 px-8 text-lg font-default font-semibold bg-primary text-primary-foreground border border-primary hover:bg-chart-2 hover:text-primary-foreground transition-all duration-300 shadow-md">
                Explore the Collection
                <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>
        </div>

      </div>
    </section>;
}